const Icon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.75"
      y="0.75"
      width="18.5"
      height="18.5"
      rx="1.25"
      stroke="black"
      strokeWidth="1.5"
    />
    <path d="M8 8L4 4M4 4V7.5M4 4H7.5" stroke="#575BFD" strokeWidth="1.5" />
    <path
      d="M12 12L16 16M16 16V12.5M16 16H12.5"
      stroke="#575BFD"
      strokeWidth="1.5"
    />
  </svg>
);

export default Icon;
